import { MainAppResource } from './base';

export default function VisnetHubFaultPanelData({ externalVisnetHubId }) {
  return MainAppResource(`api/v3/visnet_hubs/${externalVisnetHubId}/fault_events_panel{/code}`);
}
